import Image from "next/image";
import { useT } from "@/app/translations/useT";
import { ConceptFlowAvatarStack as AvatarStack } from "@/app/types/home/ConceptFlow";
import { FLOW_AVATAR_SIZE, outputSequenceStyle } from "../ConceptFlow.logic";
import styles from "../ConceptFlow.module.css";

type Props = {
  stack: AvatarStack;
  outputIndex: number;
};

export default function ConceptFlowAvatarStack(props: Props) {
  const { stack, outputIndex } = props;
  const T = useT();

  return (
    <span className={styles.avatarStack} aria-hidden="true">
      <span className={styles.avatarStackPhotos}>
        {stack.photos.map((photo, index) => (
          <Image
            className={styles.stackAvatar}
            style={outputSequenceStyle(outputIndex, index)}
            src={photo}
            alt=""
            width={FLOW_AVATAR_SIZE}
            height={FLOW_AVATAR_SIZE}
            unoptimized
            key={photo}
          />
        ))}
      </span>
      <span className={styles.avatarStackCount}>{T(stack.countKey)}</span>
    </span>
  );
}
